import React, { useEffect, useState } from 'react';
import Lottie from 'lottie-react';

const FALLBACK_ICON =
  'https://img.freepik.com/free-vector/cute-leprechaun-cartoon-character_1308-133774.jpg';

interface GameIconPreviewProps {
  src?: string | null;
  alt: string;
}

const getExtension = (url: string) =>
  url.split('?')[0].split('.').pop()?.toLowerCase();

// Game icons can be images, videos (mp4/webm) or Lottie animations (json)
const GameIconPreview: React.FC<GameIconPreviewProps> = ({ src, alt }) => {
  const [animationData, setAnimationData] = useState<object | null>(null);
  const [failed, setFailed] = useState(false);
  const extension = src ? getExtension(src) : undefined;

  useEffect(() => {
    setFailed(false);
    setAnimationData(null);
    if (!src || extension !== 'json') return;

    let cancelled = false;
    fetch(src)
      .then((res) => res.json())
      .then((data) => !cancelled && setAnimationData(data))
      .catch(() => !cancelled && setFailed(true));
    return () => {
      cancelled = true;
    };
  }, [src, extension]);

  if (!src || failed) {
    return <img src={FALLBACK_ICON} alt={alt} />;
  }

  if (extension === 'mp4' || extension === 'webm') {
    return (
      <video
        key={src}
        src={src}
        autoPlay
        loop
        muted
        playsInline
        onError={() => setFailed(true)}
      />
    );
  }

  if (extension === 'json') {
    return animationData ? (
      <Lottie className="lottieIcon" animationData={animationData} loop autoplay />
    ) : null;
  }

  return <img src={src} alt={alt} onError={() => setFailed(true)} />;
};

export default GameIconPreview;
